import { Injectable } from "@angular/core";
import { HateoasBaseService } from "./hateoas-base.service";
import { HttpUtil } from "../utils/http-util";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { CommandModelPaginated } from '../models/command-model-paginated';
import { CommandModel } from '../models/command-model';
import { CommandExecutionHistoryItem } from '../models/command-execution-history.model';

@Injectable({
  providedIn: "root",
})
export class CommandService extends HateoasBaseService {
  private _httpUtil: HttpUtil;
  private resourceMessageTypes = "message-types";
  private resourceCommandExecutions = "command-executions";

  constructor(http: HttpClient, httpUtil: HttpUtil) {
    super(http, httpUtil);
    this._httpUtil = httpUtil;
  }

  public getAvailableCommands(terminalId: string): Observable<any> {
    const params = new Map<string, string>();
    params.set("terminalId", terminalId);
    return this.executeActionOnResource(
      this.resourceMessageTypes,
      "get-available-commands-by-terminal",
      null,
      null,
      params
    );
  }

  public getPrepareForm(command: CommandModel): Observable<any> {
    return this.executeActionOnResource(
      this.resourceMessageTypes,
      "prepare-command-form",
      command,
      null,
      null
    );
  }

  public executeCommand(command: CommandModel, payload: any): Observable<any> {
    const params = new Map<string, string>();
    //params.set("uuid", command.uuid);
    return this.executeActionOnResource(
      this.resourceMessageTypes,
      "execute-command",
      command,
      payload,
      null
    );
  }

  /**
   * Lista execuções de comando (HAL command-executions / get-all).
   *
   * @param terminalIds id único ou lista separada por vírgula
   * @param pageIndex índice da página (0-based)
   * @param pageSize quantidade de itens por página
   * @param sort ordenação (padrão: requestDate,desc)
   */
  public getCommandExecutions(
    terminalIds: string,
    pageIndex = 0,
    pageSize = 10,
    sort = 'requestDate,desc'
  ): Observable<any> {
    const params = new Map<string, string>();
    params.set("terminalIds", terminalIds);
    params.set("page", String(pageIndex));
    params.set("size", String(pageSize));
    params.set("sort", sort);
    return this.executeActionOnResource(
      this.resourceCommandExecutions,
      "get-all",
      null,
      null,
      params
    );
  }

  /**
   * Navega entre páginas via links HAL (first/next/prev/last), paridade admin-web.
   *
   * @param pageResource resposta paginada anterior
   * @param rel link de paginação
   */
  public fetchCommandExecutionPage(pageResource: any, rel: string): Observable<any> {
    return this.executeActionOnResource(rel, rel, pageResource, null, null);
  }

  /**
   * Reenvia uma execução (HAL `resend` no item), paridade com setera-admin-web.
   *
   * @param item linha do histórico com links HATEOAS
   */
  public resendCommandExecution(item: CommandExecutionHistoryItem): Observable<any> {
    return this.followNamedAction(item, "resend");
  }

  /**
   * Cancela uma execução (HAL `cancel` no item), paridade com setera-admin-web.
   *
   * @param item linha do histórico com links HATEOAS
   */
  public cancelCommandExecution(item: CommandExecutionHistoryItem): Observable<any> {
    return this.followNamedAction(item, "cancel");
  }

  protected getApiBaseUrl(): string {
    return environment.apisConfig.seteraTrackingHardwareApi.apiBaseUrl;
  }

  protected getMicroServiceBaseUrl(): string {
    return environment.apisConfig.seteraTrackingHardwareApi.microServiceBaseUrl;
  }
} 